import React from "react";
import HeaderComponent from "./common/Header";
import FooterComponent from "./common/Footer";
import { Outlet } from "react-router-dom";

import "../assets/scss/_Style.scss";
import "../assets/scss/_Responsive.scss";
import "../assets/scss/_GlobalResponsiveFix.scss";

function FrontLayout() {
  return (
    <>
      {location.pathname === '/customize' ? null : <HeaderComponent />}

      {/* <div className="container"> */}
      <div className={`container ${location.pathname === '/customize' ? 'mt-5' : ''}`}>
        <Outlet />
      </div>
      {/* </div> */}
      <FooterComponent />
    </>
  );
}

export default FrontLayout;
